import { useCallback, useState } from 'react';

/**
 * Works like `setState` from the class components, merging the new state with the old one instead of replacing it.
 */
export function useSetState<T extends {}>(
  initState: T,
): [T, (newState: Partial<T> | ((prevState: T) => Partial<T>)) => void] {
  const [state, setState] = useState<T>(initState);
  const setCustomState = useCallback<(newState: Partial<T> | ((prevState: T) => Partial<T>)) => void>(
    (newPartialState) => {
      if (newPartialState instanceof Function) {
        return setState((prevState) => ({ ...prevState, ...newPartialState(prevState) }));
      }

      return setState((prevState) => ({ ...prevState, ...newPartialState }));
    },
    [],
  );

  return [state, setCustomState];
}
